import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('paperwork', 'dob-verify');

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'paperwork',
  type: 'post',
  slug: [
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentUUID'],
    },
    'dob_verifications',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/paperwork/requests/paperwork-verify-dob.js